import {
  Select,
  SelectProps,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
  SelectChangeEvent,
} from '@mui/material';
import { useField } from 'formik';

type FormikDropDownProps = {
  name: string;
  label: string;
  options: Array<{
    value: string | number;
    label: string;
  }>;
  onChange?: (value: string | number) => void;
} & Omit<SelectProps, 'name'>;

export const FormikDropDown = ({ name, label, options, onChange, ...props }: FormikDropDownProps) => {
  const [field, meta, helpers] = useField(name);

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    const value = event.target.value as string | number;
    helpers.setValue(value);
    onChange?.(value);
  };

  return (
    <FormControl
      variant="filled"
      fullWidth
      error={meta.touched && Boolean(meta.error)}
      sx={{
        '& .MuiInputBase-input': { fontSize: '16px' },
        '& .MuiFormLabel-root': { fontSize: '14px' },
        ...props.sx,
      }}
    >
      <InputLabel id={`${name}-label`}>{label}</InputLabel>
      <Select labelId={`${name}-label`} label={label} value={field.value ?? ''} onChange={handleChange} {...props}>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {meta.touched && meta.error && <FormHelperText>{meta.error}</FormHelperText>}
    </FormControl>
  );
};
